<template>
  <!-- 天天报价   发起询价 -->
  <el-dialog title="上传回单" :visible.sync="isShow">
    <el-form
      class="col-2 clearfix"
      :inline="true"
      label-width="70px"
      style="padding-left: 40px"
      :model="receiptData"
      label-position="left"
    >
      <el-row>
        <el-form-item label="回单图片" style="width: 100%">
          <el-row class="photo">
            <el-row
              class="file"
              v-for="(image, index) in image_url_list"
              :key="index"
            >
              <el-row class="file-bd">
                <el-upload
                  drag
                  class="upload"
                  action="#"
                  accept=".jpg,.jpeg,.png,.bmp,,.JPG,.JPEG"
                  :before-upload="beforeAvatarUpload"
                  :show-file-list="false"
                  :http-request="fnUploadRequest"
                >
                  <!-- <img v-if="image.image_url" :src="image.image_url"> -->
                  <div v-if="!image.image_url.includes('.pdf')">
                    <img :src="image.image_url" alt="" v-if="image.image_url" />
                  </div>
                  <div v-if="image.image_url.includes('.pdf')">
                    <pdf :src="image.image_url" v-if="image.image_url"></pdf>
                  </div>
                  <i v-else class="iconfont icon-icon81"></i>
                </el-upload>
                <!-- <el-progress v-show="showProgress" :percentage="progressLength" :stroke-width="8"></el-progress> -->
              </el-row>
              <el-row>
                <a
                  target="_blank"
                  :href="image.image_url"
                  v-if="image.image_url && image.image_url.includes('.pdf')"
                  class="file-fr-label preview"
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;查看原件</a
                >
                <el-button
                  type="text"
                  class="mainColor yu-btn"
                  v-if="image.image_url && !image.image_url.includes('.pdf')"
                >
                  预览
                  <viewer>
                    <img :src="image.image_url" alt="" class="yulan" />
                  </viewer>
                </el-button>
                <el-button
                  type="text"
                  class="mainColor del-btn"
                  @click="delRow(index)"
                  >删除</el-button
                >
              </el-row>
            </el-row>
            <el-row class="file-bd-more">
              <el-row class="file-bt-more">
                <i
                  class="iconfont icon-icon2"
                  @click="addPhoto()"
                  style="font-size: 40px; color: #e5e5e5"
                ></i>
              </el-row>
            </el-row>
          </el-row>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="回单状态">
          <el-select placeholder="请选择" v-model="receiptData.receipt_status">
            <el-option label="回单已传" value="UP_LOAD" />
            <el-option label="回单已收" value="RECEIVED" />
            <el-option label="回单未传" value="UN_LOAD" v-if="isDelete" />
          </el-select>
        </el-form-item>
        <el-form-item label="快递单号">
          <el-input v-model="receiptData.express_code" placeholder="请输入" />
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="收到时间">
          <el-date-picker
            placeholder="请输入"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="receiptData.receive_time"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上传人" v-if="receiptData.operator">
          <el-input v-model="receiptData.operator" disabled />
        </el-form-item>
      </el-row>
    </el-form>
    <el-row class="btn-group sm">
      <el-button
        type="primary"
        @click="receiptMethods"
        :loading="loading"
        :disabled="
          (receiptData.receipt_status == '' || receiptData.receipt_status == null)||loading
        "
        >保 存</el-button
      >
      <el-button type="info" @click="isShow = false">取 消</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import { isSuccess, model, getImageModel } from "@/assets/js/utils";
import pdf from "vue-pdf";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      isShow: false,
      loading: false,
      // showProgress: true,
      image_url_list: [],
      receiptData: {
        receipt_status: "",
        receive_time: "",
        express_code: "",
        images_url: "",
        waybill_id: "",
        weights: "",
        operator: "",
      },
      isDelete: true,
    };
  },
  created() {},
  methods: {
    //打开弹窗
    show(row) {
      this.isShow = true;
      this.isDelete = true;
      api("waybill.receipt.query", { id: row.pid }).then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          console.log(data.image_url_list == null);
          if (data.image_url_list == null) {
            console.log("this.isDelete = false");
            this.isDelete = false;
            data.image_url_list = [];
            data.image_url_list.push(
              model.getImageModel("回单图片", "more", "Other", false)
            );
          }
          this.image_url_list = data.image_url_list;
          this.receiptData = data;
          this.receiptData.waybill_id = row.pid;
          this.receiptData.weights = row.weights;
          this.image_url_list.forEach((item) => {
            if (item.image_url.includes("zeyi-tms")) {
              let imgurl = item.image_url.split("?x-oss-process");
              item.image_url = imgurl[0];
            }
            if (item.image_url.includes("doc.haietong.")) {
              let imgurl = item.image_url.split("?Expires");
              item.image_url = imgurl[0];
              console.log(item.image_url);
            }
          });
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "application/pdf";
      if (isJPG) {
        this.$message.error("回单图片不支持上传PDF!");
      }
      return !isJPG;
    },
    addPhoto(index) {
      this.image_url_list.push(
        model.getImageModel("回单图片", "more", "Other", false)
      );
    },
    delRow(index) {
      this.image_url_list.splice(index, 1);
      if (this.image_url_list.length == 0) {
        this.receiptData.receipt_status = "UN_LOAD";
        this.receiptData.receive_time = "";
        this.receiptData.express_code = "";
        this.receiptData.operator = "";
      }
    },
    //上传回单图片
    async fnUploadRequest(option) {
      // this.imgNum++;
      // this.progressLength = 0
      // this.showProgress = true
      // const interval = setInterval(() => {
      //   if (this.progressLength >= 99) {
      //     clearInterval(interval)
      //     return
      //   }
      //   this.progressLength += 1
      // }, 20)
      this.loading = true;
      api("aliyun.sts.verify").then((res) => {
        let data;
        if ((data = isSuccess(res))) {
          this.loading = false;
          let OSS = require("ali-oss");
          let store = new OSS({
            region: data.aliyun_region,
            accessKeyId: data.access_key_id,
            accessKeySecret: data.access_key_secret,
            stsToken: data.security_token,
            bucket: data.aliyun_bucket,
          });
          let random_name =
            this.guid() + "." + option.file.name.split(".").pop();
          store.put(random_name, option.file).then((res) => {
            this.image_url_list.push({
              image_url: res.url,
            });
            this.image_url_list.forEach((item, index) => {
              if (item.image_url == "") {
                this.image_url_list.splice(index, 1);
              }
            });
            console.log(this.image_url_list);
            // this.progressLength = 100
            // this.showProgress = false
            let arr = [];
            this.image_url_list.forEach((item) => {
              arr.push(item.image_url);
            });
            this.receiptData.images_url = arr.join(",");
            this.receiptData.receipt_status = "UP_LOAD";
          });
        }
      });
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    // 确认
    receiptMethods() {
      console.log(this.image_url_list);
      if (this.image_url_list) {
        let arr = [];
        this.image_url_list.forEach((item) => {
          arr.push(item.image_url);
        });
        this.receiptData.images_url = arr.join(",");
      } else {
        this.receiptData.images_url = "";
      }
      this.loading = true;
      console.log(this.receiptData.images_url);
      console.log(" this.isDelete ==" + this.isDelete);
      console.log(this.receiptData.images_url == "" && this.isDelete == false);
      if (this.receiptData.images_url == "" && this.isDelete == false) {
        alert("保存成功");
        this.loading = false;
        this.isShow = false;
        this.$emit("upup");
      } else {
        api("waybill.receipt.create", this.receiptData).then((res) => {
          let data;
          alert(res.msg);
          this.loading = false;
          if ((data = isSuccess(res))) {
            this.isShow = false;
            this.$emit("upup");
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "src/assets/sass/mixin";
.file-bd-more {
  height: 140px;
  width: 160px;
  overflow: hidden;
}
.file-bt-more {
  padding: 10px;
  text-align: center;
  height: 140px;
  line-height: 120px;
  border: 1px dashed $borderColor;
}
.del-btn {
  font-size: 14px;
  color: #cc0816;
  float: right;
}
.yu-btn {
  font-size: 14px;
  color: #cc0816;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/waybill-receipt.vue